import { getUserRole } from "../../helpers/api_helper";
const role = getUserRole();

// Define the extra sidebar items for different roles



const adminSidebarItems = [
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Machine List",
    icon: "mdi mdi-home-variant-outline",
    url: "/listMachines",
    isHasArrow: true,
  },
  {
    label: "Overview",
    icon: "mdi mdi-home-variant-outline",
    url: "/",
    isHasArrow: true,
  },
  {
    label: "Dashboard",
    icon: "bx bxs-dashboard",
    url: "/dashboard",
    isHasArrow: true,
  },
  
   {
    label: "VessalControl",
    icon: "ri-brush-line",
    url: "/vessalControl",
    isHasArrow: true,
  },
  {
    label: "Batch Control",
    icon: "mdi mdi-receipt",
    isHasArrow: true,
    url: "/batch-control-page",
  },
  {
    label: "Batch Control Data",
    icon: "mdi mdi-receipt",
    url: "/batch-control",
    isHasArrow: true,
  },
   {
    label: "Reports",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/reports",
  },
  {
    label: "Production Planning",
    icon: "mdi mdi-factory",
    isHasArrow: true,
    url: "/production-planning-page",
  },
  {
    label: "Production Planning data",
    icon: "mdi mdi-factory",
    url: "/production-planning",
    isHasArrow: true,
  },
  {
    label: "Quality Dashboard",
    icon: "mdi mdi-chart-line",
    isHasArrow: true,
    url: "/quality-dashboard",
  },

  {
    label: "User",
    icon: "mdi mdi-account-circle-outline",
    isHasArrow: true,
    url: "/user",
  },
  {
    label: "Operator",
    icon: "mdi mdi-account-circle-outline",
    isHasArrow: true,
    url: "/operator",
  },
  {
    label: "Traceability ProductionQC",
    icon: "mdi mdi-factory",
    isHasArrow: true,
    url: "/traceability-production-qc",
  },
    {
    label: "Traceability Assembly-Production",
    icon: " fas fa-business-time",
    isHasArrow: true,
    url: "/traceability-assembly-production",
  },
  {
    label: "Traceability Assembly-QC",
    icon: " fas fa-business-time",
    isHasArrow: true,
    url: "/traceability-assembly-qc",
  },
  {
    label: "Company",
    icon: " fas fa-business-time",
    isHasArrow: true,
    url: "/company",
  },
  {
    label: "Production Setup",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/ProductionSetUp",
  },
  {
    label: "Machine",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/machine",
  },
  {
    label: "Parts",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/parts",
  },
  {
    label: "Bill of Material",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/child-parts",
  },
    {
    label: "Material Request",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/material-request",
  },
   {
    label: "ChildPart Inventory",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/child-parts-inventory",
  },
  {
    label: "Inventory",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/inventory",
  },
  {
    label: "Spare list",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/spare-list",
  },
  {
    label: "Advanced Analysis",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/advanced-analysis",
  },
  {
    label: "Inventory Upload",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/invetoryupload",
  },
    {
    label: "Equipment List",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/equipmentList",
  },
   {
    label: "Add Alarms",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/addAlarms",
  },
  //  {
  //   label: "Machine DownTime Updation",
  //   icon: "mdi mdi-factory",
  //   isHasArrow: true,
  //   url: "/machine-downtime-updation",
  // },
];

const qualityManagerSidebarItems = [
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Overview",
    icon: "mdi mdi-home-variant-outline",
    url: "/",
    isHasArrow: true,
  },
  {
    label: "Dashboard",
    icon: "bx bxs-dashboard",
    url: "/dashboard",
    isHasArrow: true,
  },
    {
    label: "Inventory Upload",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/invetoryupload",
  },
    {
    label: "Traceability ProductionQC",
    icon: "mdi mdi-factory",
    isHasArrow: true,
    url: "/traceability-production-qc",
  },
    {
    label: "Traceability Assembly-Production",
    icon: " fas fa-business-time",
    isHasArrow: true,
    url: "/traceability-assembly-production",
  },
  {
    label: "Traceability Assembly-QC",
    icon: " fas fa-business-time",
    isHasArrow: true,
    url: "/traceability-assembly-qc",
  },
   {
    label: "Production Setup",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/ProductionSetUp",
  },
   {
    label: "Production Planning",
    icon: "mdi mdi-factory",
    isHasArrow: true,
    url: "/production-planning-page",
  },
   {
    label: "Batch Control",
    icon: "mdi mdi-receipt",
    isHasArrow: true,
    url: "/batch-control-page",
  },
  {
    label: "Performance",
    icon: "ri-brush-line",
    url: "/performance",
    isHasArrow: true,
  },
   {
    label: "Reports",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/reports",
  },
  //  {
  //   label: "Machine DownTime Updation",
  //   icon: "mdi mdi-factory",
  //   isHasArrow: true,
  //   url: "/machine-downtime-updation",
  // },
  // {
  //   label: "Quality Dashboard",
  //   icon: "mdi mdi-chart-line",
  //   isHasArrow: true,
  //   url: "/quality-dashboard",
  // },
];

const batchControlManagerSidebarItems = [
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Main",
    icon: "mdi mdi-home-variant-outline",
    url: "/",
    isHasArrow: true,
  },
  {
    label: "Dashboard",
    icon: "bx bxs-dashboard",
    url: "/dashboard",
    isHasArrow: true,
  },
  {
    label: "Performance",
    icon: "ri-brush-line",
    url: "/performance",
    isHasArrow: true,
  },
  {
    label: "Batch Control",
    icon: "mdi mdi-receipt",
    isHasArrow: true,
    url: "/batch-control-page",
  },
   {
    label: "Reports",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/reports",
  },
];

const productionManagerSidebarItems = [
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Main",
    icon: "mdi mdi-home-variant-outline",
    url: "/",
    isHasArrow: true,
  },
  {
    label: "Dashboard",
    icon: "bx bxs-dashboard",
    url: "/dashboard",
    isHasArrow: true,
  },
   {
    label: "Batch Control",
    icon: "mdi mdi-receipt",
    isHasArrow: true,
    url: "/batch-control-page",
  },
  {
    label: "Performance",
    icon: "ri-brush-line",
    url: "/performance",
    isHasArrow: true,
  },
  {
    label: "Production Planning",
    icon: "mdi mdi-factory",
    isHasArrow: true,
    url: "/production-planning-page",
  },
   {
    label: "Reports",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/reports",
  },
   {
    label: "Operator",
    icon: "mdi mdi-account-circle-outline",
    isHasArrow: true,
    url: "/operator",
  },
   {
    label: "Traceability ProductionQC",
    icon: "mdi mdi-factory",
    isHasArrow: true,
    url: "/traceability-production-qc",
  },
    {
    label: "Traceability Assembly-Production",
    icon: " fas fa-business-time",
    isHasArrow: true,
    url: "/traceability-assembly-production",
  },
  {
    label: "Traceability Assembly-QC",
    icon: " fas fa-business-time",
    isHasArrow: true,
    url: "/traceability-assembly-qc",
  },
   {
    label: "Inventory Upload",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/invetoryupload",
  },
];
const userSidebarItems = [
  {
    label: "Menu",
    isMainMenu: true,
  },
 
  {
    label: "Vessel Dashboard",
    
    icon: "mdi mdi-home-variant-outline",
    url: "/vesseldashboard",
    isHasArrow: true,
  },
  // {
  //   label: "Performance",
  //   icon: "ri-brush-line",
  //   url: "/performance",
  //   isHasArrow: true,
  // },
  //  {
  //   label: "VessalControl",
  //   icon: "ri-brush-line",
  //   url: "/vessalControl",
  //   isHasArrow: true,
  // },
  //   {
  //   label: "Equipment List",
  //   icon: "mdi mdi-state-machine",
  //   isHasArrow: true,
  //   url: "/equipmentList",
  // },
    {
    label: "Equipment Overview",
    icon: "bx bxs-dashboard",
    isHasArrow: true,
    url: "/equip2",
  },
   {
    label: "Auxiliary Engine",
    icon: "mdi mdi-state-machine",
    url: "/auxiliaryEngine1",
    isHasArrow: true,
  },
  //  {
  //   label: "Overview",
  //   icon: "bx bxs-dashboard",
  //   url: "/",
  //   isHasArrow: true,
  // },
  //   {
  //   label: "Dashboard",
  //   icon: "bx bxs-dashboard",
  //   url: "/dashboard",
  //   isHasArrow: true,
  // },
  
  //  {
  //   label: "Production Setup",
  //   icon: "mdi mdi-state-machine",
  //   isHasArrow: true,
  //   url: "/ProductionSetUp",
  // },
 
  //  {
  //   label: "Batch Control",
  //   icon: "mdi mdi-receipt",
  //   isHasArrow: true,
  //   url: "/batch-control-page",
  // },
   {
    label: "Monitor",
    icon: "ri-brush-line",
    url: "/monitor",
    isHasArrow: true,
  },
   {
    label: "PerformanceOverview",
    icon: "mdi mdi-factory",
    isHasArrow: true,
    url: "/performanceOverview",
  },
  //  {
  //   label: "Reports",
  //   icon: "mdi mdi-state-machine",
  //   isHasArrow: true,
  //   url: "/reports",
  // },
  //  {
  //   label: "Machine DownTime Updation",
  //   icon: "mdi mdi-factory",
  //   isHasArrow: true,
  //   url: "/machine-downtime-updation",
  // },
];
const demoSidebarItems =[
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Overview",
    icon: "mdi mdi-home-variant-outline",
    url: "/",
    isHasArrow: true,
  },
  {
    label: "Dashboard",
    icon: "bx bxs-dashboard",
    url: "/dashboard",
    isHasArrow: true,
  },
   {
    label: "Performance",
    icon: "ri-brush-line",
    url: "/performance",
    isHasArrow: true,
  },
 {
    label: "Advanced Analysis",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/advanced-analysis",
  },
   {
    label: "DownTime Analysis",
    icon: "mdi mdi-state-machine",
    isHasArrow: true,
    url: "/downtime-analysis",
  },
    {
    label: "Batch Control",
    icon: "mdi mdi-receipt",
    isHasArrow: true,
    url: "/batch-control-page",
  },
   {
    label: "ProductionDemand",
    icon: "mdi mdi-factory",
    isHasArrow: true,
    url: "/productionDemand",
  },
  // {
  //   label: "Parts",
  //   icon: "ri-brush-line",
  //   isHasArrow: true,
  //   url: "/parts",
  // },
    {
    label: "Bill of Material",
    icon: "fas fa-business-time",
    isHasArrow: true,
    url: "/child-parts",
  },
  {
    label: "Reports",
    icon: "mdi mdi-chart-line",
    isHasArrow: true,
    url: "/productionReport",
  },
];
const testSidebarItems =[
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Overview",
    icon: "mdi mdi-home-variant-outline",
    url: "/",
    isHasArrow: true,
  },
  {
    label: "Temperature Dashboard",
    icon: "bx bxs-dashboard",
    url: "/temperatureTrend",
    isHasArrow: true,
  },


]


export {
  adminSidebarItems,
  qualityManagerSidebarItems,
  batchControlManagerSidebarItems,
  productionManagerSidebarItems,
  userSidebarItems,
  demoSidebarItems,
  testSidebarItems
};
